import { FC } from 'react'
import { AnalyticsPlaces } from '../../analyticsPlaces'
import { ASharedModal, SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import { useTranslation } from 'react-i18next'
import { CarStatuses, LogisticsKRCar } from '../../types'
import { Progress } from '@agro-club/agroclub-shared'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { useNotification } from 'hooks/useNotification'
import { apiClient } from 'modules/utils/httpClient'
import { refetchFunc } from 'modules/domain/common/hooks'

interface Props {
  car: LogisticsKRCar
  onClose: () => void
  onSuccess: refetchFunc
}

export const ArchivedConfirmModal: FC<Props> = ({ onClose, car, onSuccess }) => {
  const { t } = useTranslation('logisticsKR')
  const notify = useNotification()
  const [progress, changeStatusToArchived] = useAProgress(
    (carId: string) => apiClient.post(endpoints.LogisticsKR.carStatus(carId), { new_status: CarStatuses.archived }),
    {
      eventName: 'archiveCar',
      onSuccess: () => {
        onSuccess(true)
        notify(Progress.SUCCESS, { title: t('carsEdit.notifications.car_archived_success') })
        onClose()
      },
      onError: () => notify(Progress.ERROR, { title: t('carsEdit.notifications.car_archived_error') }),
    },
  )

  return (
    <ASharedModal id={AnalyticsPlaces.CARRIERS.ARCHIVE_CAR_MODAL} size="small" onClose={onClose}>
      <SharedModalTitle>{t('carsDetails.archiveForm.title')}</SharedModalTitle>
      <SharedModalContent>{t('carsDetails.archiveForm.text')}</SharedModalContent>
      <ADefaultModalFooter
        progress={progress}
        onClose={onClose}
        onConfirm={() => changeStatusToArchived(car.id)}
        confirmButtonText={t('common:archive')}
      />
    </ASharedModal>
  )
}
